export const selectAllInputValue = (event) => {
  const value = getUnmaskedValue(event.target.value || '');
  if (value.length === 0) {
    event.target.selectionStart = 0;
    event.target.selectionEnd = value.length - 1;
  }
};

export const setCursorToStartPosition = (event) => {
  const value = getUnmaskedValue(event.target.value || '');
  if (value.length === 0) {
    event.target.selectionStart = 0;
    event.target.selectionEnd = 0;
  }
};

export const getPhoneMask = () => {
  return [
    '(',
    /[1-9]/,
    /\d/,
    ')',
    ' ',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ];
};

export const getTimeMask = () => {
  return [/[0-9]/, /\d/, ':', /\d/, /\d/];
};

export const getDateMask = () => {
  return [/[0-9]/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
};

export const getMediaMask = () => {
  return [/[0-9]/, /[0-9]/, '.', /\d/];
};

export const getCPFMask = () => {
  return [
    /[0-9]/,
    /\d/,
    /\d/,
    '.',
    /[0-9]/,
    /\d/,
    /\d/,
    '.',
    /[0-9]/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
  ];
};

export const getCNPJMask = () => {
  return [
    /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, '.',
    /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, '.',
    /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, '/',
    /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, '-',
    /[a-zA-Z0-9]/, /[a-zA-Z0-9]/
  ];
};

export const getCEPMask = () => {
  return [/[0-9]/, /\d/, /\d/, /\d/, /\d/, '-', /[0-9]/, /\d/, /\d/];
};

export const getNumberOfCurrencyStr = (value, decimalSeparator) => {
  let sanitizedValue = String(value)
    .replace('R$ ', '')
    .replace(/\./g, '')
    .replace(decimalSeparator, '.');
  if (!isNaN(Number(sanitizedValue))) {
    return Number(sanitizedValue);
  }
  return 0;
};

export const formatToCurrency = (value, decimalSeparator = ',') => {
  if (typeof value !== 'number') {
    throw new TypeError('O valor deve ser um número');
  }

  let numberValue = value.toFixed(2);
  let integerPart = Math.floor(value);
  let decimalPart = (numberValue - integerPart).toFixed(2).slice(2);
  let formattedInteger = integerPart.toLocaleString('pt-BR');
  return `R$ ${formattedInteger}${decimalSeparator}${decimalPart}`;
};

export const getCurrencyOfNumber = (value, decimalSeparator) => {
  return String(Number(value).toFixed(2)).split('.').join(decimalSeparator);
};

export const getCurrencyNumberWithoutDecimal = (value, decimalSeparator) => {
  return String(Number(value).toFixed(0)).split('.').join(decimalSeparator);
};

export const getUnmaskedCurrencyValue = (value, decimalSeparator) => {
  let arrValue = [];
  value
    .trim()
    .split(decimalSeparator + decimalSeparator)
    .join(decimalSeparator)
    .split('')
    .map((char, index) => {
      switch (char) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case '0':
        case '1':
        case '2':
        case '3':
        case '4':
        case '5':
        case '6':
        case '7':
        case '8':
        case '9':
        case decimalSeparator:
          arrValue.push(char);
          return index;
        default:
          return index;
      }
    });
  let newValue = arrValue.join('');
  if (
    newValue.split('').filter((char) => char === decimalSeparator).length > 1
  ) {
    newValue = newValue.replace(decimalSeparator, '');
  }
  let lastDecimalSeparatorIndex = newValue.lastIndexOf(decimalSeparator);
  if (
    lastDecimalSeparatorIndex > -1 &&
    newValue.length > lastDecimalSeparatorIndex + 3
  ) {
    newValue = newValue.substr(0, lastDecimalSeparatorIndex + 3);
  }
  if (value !== newValue) {
    newValue = getUnmaskedCurrencyValue(newValue, decimalSeparator);
  }
  return newValue;
};

export const getUnmaskedValue = (value) => {
  return value
    .trim()
    .split('')
    .filter(char => /[a-zA-Z0-9]/.test(char)) // mantém letras e números
    .join('');
};

export const formatDateToISO = (value) => {
  if (!value) return '';
  const unmasked = getUnmaskedValue(value);
  if (unmasked.length !== 8) return '';
  const day = unmasked.substring(0, 2);
  const month = unmasked.substring(2, 4);
  const year = unmasked.substring(4, 8);

  return `${year}-${month}-${day}`;
};
